// extracted by mini-css-extract-plugin
export var avatarContainer = "_g1-0";
export var avatarTypingWave = "_g1-i";
export var gray = "_g1-f";
export var green = "_g1-c";
export var icon = "_g1-9";
export var image = "_g1-1";
export var lg = "_g1-6";
export var md = "_g1-5";
export var presenceDot = "_g1-b";
export var red = "_g1-d";
export var sm = "_g1-4";
export var status = "_g1-a";
export var typingDot = "_g1-h";
export var typingPill = "_g1-g";
export var xl = "_g1-7";
export var xs = "_g1-3";
export var xxl = "_g1-8";
export var xxs = "_g1-2";
export var yellow = "_g1-e";